import { Link } from 'react-router-dom';
import { BrandMark } from './ui';
import { brand } from '../config/brand';

/**
 * Footer.
 *
 * Every link here goes somewhere real. Owner-supplied identity (NIB, address,
 * chat channels, admin hours) comes from env and each block disappears when its
 * value is empty — an invented NIB or a `href="#"` "Panduan" is exactly the kind
 * of lie the redesign exists to remove. The "System Online" dot is gone with it:
 * it checked nothing.
 */

/** The main product — convert PayPal ke Rupiah — lives on its own site. */
const LBA_MAIN_URL = 'https://lapakbangade.com';

const LAYANAN = [
  { label: 'Jastip Belanja', to: '/jasa/belanja' },
  { label: 'Toko', to: '/toko' },
  { label: 'Cek Harga', to: '/cek-harga' },
  { label: 'Titip carikan lisensi', to: '/toko/titip-lisensi' },
];

const BANTUAN = [
  { label: 'Syarat & Ketentuan', to: '/syarat' },
  { label: 'Kebijakan Privasi', to: '/privasi' },
  { label: 'Kebijakan Refund', to: '/refund' },
];

// 34px rows, not 44px: these are a tight column of secondary text links, and
// 44px each left the list visibly loose. Still clears the WCAG 2.5.8 (AA)
// 24px minimum target with room to spare.
const linkClass =
  'inline-flex min-h-[34px] items-center text-[14.5px] font-semibold text-body no-underline transition-colors duration-150 ease-out hover:text-link-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink';

export const Footer = () => {
  const hasKontak = brand.hasWhatsapp || brand.hasMessenger || brand.hasAdminHours;

  return (
    <footer className="mt-auto border-t-2 border-line bg-white">
      <div className="mx-auto max-w-[1180px] px-5 py-12 md:px-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <BrandMark />
            <p className="mt-4 max-w-[34ch] text-[14.5px] font-semibold leading-[1.55] text-body">
              Jasa titip belanja luar negeri dan toko barang koleksi serta lisensi digital.
              Harga dulu, akun belakangan.
            </p>
            {/* Sister product cross-link; lapakbangade.com links back the same way. */}
            <a
              href={LBA_MAIN_URL}
              target="_blank"
              rel="noreferrer noopener"
              className="mt-4 flex max-w-[34ch] flex-col gap-[2px] rounded-block border-2 border-line px-4 py-3 no-underline transition-colors duration-150 ease-out hover:border-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink"
            >
              <span className="font-mono text-[9px] font-semibold tracking-[0.11em] text-muted">
                JUGA DARI LAPAK BANG ADE
              </span>
              <span className="text-[14.5px] font-extrabold text-ink">
                Convert PayPal ke Rupiah
              </span>
              <span className="font-mono text-[12.5px] font-medium text-body">lapakbangade.com</span>
            </a>
          </div>

          <div>
            <h2 className="mb-1 text-[13px] font-extrabold tracking-[0.05em] text-ink">LAYANAN</h2>
            <ul className="flex flex-col">
              {LAYANAN.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className={linkClass}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="mb-1 text-[13px] font-extrabold tracking-[0.05em] text-ink">BANTUAN</h2>
            <ul className="flex flex-col">
              {BANTUAN.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className={linkClass}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {hasKontak && (
            <div>
              <h2 className="mb-1 text-[13px] font-extrabold tracking-[0.05em] text-ink">KONTAK</h2>
              <ul className="flex flex-col">
                {brand.whatsappUrl && (
                  <li>
                    <a
                      href={brand.whatsappUrl}
                      target="_blank"
                      rel="noreferrer noopener"
                      className={linkClass}
                    >
                      WhatsApp
                    </a>
                  </li>
                )}
                {brand.messengerUrl && (
                  <li>
                    <a
                      href={brand.messengerUrl}
                      target="_blank"
                      rel="noreferrer noopener"
                      className={linkClass}
                    >
                      Messenger
                    </a>
                  </li>
                )}
              </ul>
              {brand.adminHours && (
                <p className="text-[14.5px] font-semibold text-muted">
                  Admin dibalas {brand.adminHours}
                </p>
              )}
            </div>
          )}
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t-2 border-line pt-6 text-[13.5px] font-semibold text-muted md:flex-row md:items-center md:justify-between">
          <p>
            &copy; {new Date().getFullYear()} {brand.displayName}
          </p>
          {(brand.businessNib || brand.businessAddress) && (
            <p className="md:text-right">
              {brand.businessNib && <span>NIB {brand.businessNib}</span>}
              {brand.businessNib && brand.businessAddress && <span> &middot; </span>}
              {brand.businessAddress && <span>{brand.businessAddress}</span>}
            </p>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
